import {Box, Center, Flex, Image, Text} from '@chakra-ui/react'
import BackGround from '@assets/images/learn/bg-vocabulary-result.png'
import BookImage from '@assets/images/learn/book.png'
import ArrowRightIcon from '@assets/svgs/learn/arrow_right_6.svg'
import {useLocation, useNavigate} from 'react-router-dom'
import {PATH} from '@utils/Const'

const Header = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const {setName, entry_point, task_id} = location.state || {}

  const handleClickBtn = () => {
    if (entry_point === 'ROADMAP') {
      navigate(PATH.ROADMAP_SUMMARY, {
        state: {
          task_id,
        },
      })
    } else {
      navigate(-3)
    }
  }

  return (
    <Box
      h={{base: '350px', md: '320px'}}
      bgImage={BackGround}
      bgSize={'cover'}
      bgRepeat={'no-repeat'}>
      <Flex
        className="container-xl"
        flexWrap={{base: 'wrap', md: 'unset'}}
        px={{base: '16px', md: '40px'}}
        pt={'50px'}
        gap={{base: '16px', md: '32px'}}
        alignItems={'center'}>
        <Image src={BookImage} w={{base: '80px', md: 'unset'}} />
        <Box flex={1}>
          <Box maxW={'450px'}>
            <Text
              fontSize={{base: '16px', md: '24px'}}
              fontWeight={600}
              color={'#263238'}>
              Chúc mừng bạn đã học xong chủ đề {setName}
            </Text>
            <Text fontSize={'16px'} color={'#546E7A'} mt={'8px'}>
              Cùng xem lại các cụm từ bạn đã hoàn thành nhé!
            </Text>
          </Box>
        </Box>
        <Flex flexBasis={{base: '100%', md: 'unset'}} justifyContent={'center'}>
          <Center
            w={{base: '100px', md: '150px'}}
            h={{base: '40px', md: '48px'}}
            gap={'8px'}
            bg={'#FA8C16'}
            borderRadius={'12px'}
            cursor={'pointer'}
            onClick={handleClickBtn}>
            <Text fontSize={'16px'} fontWeight={700} color={'white'}>
              {entry_point === 'ROADMAP' ? 'Hoàn thành' : 'Học tiếp'}
            </Text>
            <Image src={ArrowRightIcon} display={{base: 'none', md: 'block'}} />
          </Center>
        </Flex>
      </Flex>
    </Box>
  )
}

export default Header
